export const SITUACOES = [
  { id: 1, nome: 'Cadastrada' },
  { id: 2, nome: 'Edital Publicado' },
  { id: 3, nome: 'Entrega de Propostas' },
  { id: 4, nome: 'Aguardando Início de Sessão' },
  { id: 5, nome: 'Analisando Propostas' },
  { id: 6, nome: 'Lances' },
  { id: 7, nome: 'Preferência' },
  { id: 8, nome: 'Negociação' },
  { id: 9, nome: 'Habilitação' },
  { id: 10, nome: 'Interposição de Recursos' },
  { id: 11, nome: 'Adesão de Preço' },
  { id: 12, nome: 'Fracassada' },
  { id: 13, nome: 'Deserta' },
  { id: 14, nome: 'Revogada' },
  { id: 15, nome: 'Encerrada com Vencedor' },
  { id: 16, nome: 'Encerrada com Recurso' },
  { id: 17, nome: 'Suspensa' },
  { id: 18, nome: 'Anulada' },
  { id: 19, nome: 'Julgamento' },
];

export const BUCKET_SITUACAO_IDS = {
  nao_publicadas: [1],
  recebendo_propostas: [3],
  baixa_concorrencia: [3],
  estou_participando: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 17, 19],
  participei: [12, 13, 14, 15, 16, 18],
  fui_vencedor: [15, 16],
  em_andamento: [4, 5, 6, 7, 8, 9, 10, 11, 19],
  concluidas: [12, 13, 14, 15, 16, 18],
};

export const CHIPS_BY_PERSONA = {
  licitante: [
    { value: null, label: 'Todas' },
    { value: 'recebendo_propostas', label: 'Recebendo Propostas' },
    { value: 'baixa_concorrencia', label: 'Baixa Concorrência' },
    { value: 'estou_participando', label: 'Estou Participando' },
    { value: 'participei', label: 'Participei' },
    { value: 'fui_vencedor', label: 'Fui Vencedor' },
  ],
  visitante: [
    { value: null, label: 'Todas' },
    { value: 'recebendo_propostas', label: 'Recebendo Propostas' },
    { value: 'baixa_concorrencia', label: 'Baixa Concorrência' },
    { value: 'em_andamento', label: 'Em Andamento' },
    { value: 'concluidas', label: 'Concluídas' },
  ],
  pregoeiro: [
    { value: null, label: 'Todas' },
    { value: 'nao_publicadas', label: 'Não Publicadas' },
    { value: 'recebendo_propostas', label: 'Recebendo Propostas' },
    { value: 'em_andamento', label: 'Em Andamento' },
    { value: 'concluidas', label: 'Concluídas' },
  ],
};

export const MODALIDADES = [
  { id: 'PREGAO', nome: 'Pregão' },
  { id: 'CONCORRENCIA', nome: 'Concorrência' },
  { id: 'DISPENSA', nome: 'Dispensa' },
];

export const TIPOS_EDITAL = [
  { id: 'AMPLO', nome: 'Participação Ampla' },
  {
    id: 'AMPLOCOTA',
    nome: 'Com Quota Reservada para ME/EPP/MEI/Cooperativa Preferência',
  },
  {
    id: 'RESERVADO',
    nome: 'Participação Exclusiva de ME/EPP/MEI/Cooperativa Preferência',
  },
];

export const TIPOS_PREGAO = [
  { id: 'IMEDIATO', nome: 'Contratação Imediata' },
  { id: 'REGISTRO', nome: 'Registro de Preços' },
];

export const UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
].map(sigla => ({ id: sigla, nome: sigla }));

export const getSituacoesForBucket = bucket => {
  if (!bucket || !BUCKET_SITUACAO_IDS[bucket]) return SITUACOES;
  return SITUACOES.filter(situacao => BUCKET_SITUACAO_IDS[bucket].includes(situacao.id));
};

/** IDs de situação a selecionar no multiselect ao acionar um chip rápido. */
export const getSituacaoIdsForBucket = bucket => {
  if (!bucket || !BUCKET_SITUACAO_IDS[bucket]) return [];
  return [...BUCKET_SITUACAO_IDS[bucket]];
};

/** True se a seleção do multiselect corresponde exatamente ao chip ativo ("Todas" só bate com seleção vazia). */
export const situacaoIdsMatchBucket = (selectedIds = [], bucket) => {
  const selected = selectedIds
    .map(Number)
    .filter(Number.isFinite)
    .sort((a, b) => a - b);
  if (bucket == null) return selected.length === 0;
  if (!BUCKET_SITUACAO_IDS[bucket]) return true;
  const expected = BUCKET_SITUACAO_IDS[bucket].map(Number).sort((a, b) => a - b);
  if (expected.length !== selected.length) return false;
  return expected.every((id, index) => id === selected[index]);
};

export const adjustSituacaoIdsForBucket = (selectedIds = [], bucket) => {
  if (!bucket || !BUCKET_SITUACAO_IDS[bucket]) return selectedIds;
  return selectedIds.filter(id => BUCKET_SITUACAO_IDS[bucket].includes(Number(id)));
};
